
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { MaterialModule } from "../../material.module";
import { LeftMenuComponent } from "../../menu/left-menu/left-menu.component";
import { SpinnerComponent } from "../../shared/spinner/spinner.component";
import { ModernizationReadinessComponent } from "../modernization-readiness/modernization-readiness.component";

@Component({
  selector: "ai-cmdb-assessment",
  templateUrl: "./ai-cmdb-assessment.component.html",
  styleUrls: ['./ai-cmdb-assessment.component.scss'],
    imports: [FormsModule, MaterialModule, LeftMenuComponent, SpinnerComponent, ModernizationReadinessComponent]
})
export class AiCmdbAssessmentComponent implements OnInit {

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {}
}
